import React from "react";
import { bindActionCreators } from 'redux';
import { getHostUrl } from '../../store/apiWrapper';
import { Circles } from "../common/loadingComponent";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import { getElementHeight, getClientWindowHeight } from '../../store/almightyElementWrapper';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { layoutActions } from "../../store/layoutStore";
import { marketingListActions, overviewStates, unicornCountry } from '../../store/marketingListStore';
import { withLocalize, Translate } from "react-localize-redux";
import classnames from 'classnames';
import OverviewContent from './overviewContent';
import Paging from "../common/pagingComponent";
import RefreshComponent from "../layoutItems/refreshComponent";
import RequestResultRow from './requestResultRow';
import ResponsiveTable from "../layoutItems/responsiveTable";
import CrossIcon from '../../img/icons/Cross';
import UnDockIcon from '../../img/icons/SkyMinderAirating';
import SvgBBiconsHandlebar from '../../img/icons/BBicons_Handlebar2';
import ReactResizeDetector from 'react-resize-detector';
import { isIE } from "../common/utils";
import Message from '../common/message';

class MarketingListResults extends React.Component {
    state = {
        initialized: false,
        ovHeight: null,
        initialHeight: null,
        autoRefresh: false,
        intervalId: null,
    }
    timer = null;

    componentDidMount() {
        if (this.props.path === `/unicorn/${unicornCountry()}/file/:id`)
            window.open(`/files/marketing-list/result/${this.props.computedMatch.params["id"]}`, "_blank");
        this.getRequestsOrTemplates(0, this.props.pageSize);
    }

    componentWillUnmount() {
        this.props.toggleMlOverview(overviewStates.closed, null, null, null);

        if (this.state.initialized) {
            let gridRef = document.querySelector('.marketing-root');
            if (gridRef) {
                gridRef.removeEventListener('mousemove', this.handleMouseMove);
                gridRef.removeEventListener('mouseup', this.handleMouseUp);
                gridRef.removeEventListener('mouseleave', this.handleMouseLeave);
            }
        }

        clearTimeout(this.timer);
    }

    componentDidUpdate(prevProps) {
        if (!this.state.initialized) {
            let gridRef = document.querySelector('.marketing-root');
            if (gridRef) {
                gridRef.addEventListener('mousemove', this.handleMouseMove);
                gridRef.addEventListener('mouseup', this.handleMouseUp);
                gridRef.addEventListener('mouseleave', this.handleMouseLeave);
            }
            this.setState({ initialized: true });
        }
        if (prevProps && prevProps.overviewState === overviewStates.closed && this.props.overviewState === overviewStates.overview && isIE()) {
            setTimeout(() => { document.getElementById('card').style.height = document.getElementById('content-root').clientHeight + 'px'; }, 200);
            setTimeout(() => { document.getElementById('card').style.height = null; }, 400);
        }
        if (prevProps && prevProps.match.url === this.props.match.url &&
            prevProps.isLoading && !this.props.isLoading && this.state.autoRefresh)
            this.setTimer(5000);

        if (prevProps && prevProps.match.url !== this.props.match.url)
            this.getRequestsOrTemplates(0, this.props.pageSize);
    }

    render() {
        var mainStyle = { fontSize: "1em" };
        if (this.props.overviewState === overviewStates.overview) {
            mainStyle.height = (this.state.ovHeight ? (this.height() - this.state.ovHeight) : (this.height() / 2)) - 4 + 'px';
            mainStyle.overflowY = 'auto';
            mainStyle.marginBottom = 0;
        }
        return (
            <div>
                <div className="content-root" id="content-root" style={mainStyle}>
                    {this.isResultsPage() ? <RefreshComponent style={{ margin: "1em 0" }} autoRefresh={this.state.autoRefresh} onAutoRefresh={() => this.onAutoRefresh(!this.state.autoRefresh)} onRefresh={() => this.getRequestsOrTemplates(this.props.page - 1, this.props.pageSize)} /> : <div style={{ margin: "1em 0" }} />}
                    {this.props.isLoading && <Circles />}
                    {this.props.error && <Message type="error" style={{ marginTop: "1em" }}
                        message={this.props.translate(((this.props.error.data || {}).error || {}).message || "UnhappyUser.InternalServerError")} options={{ renderInnerHtml: true }}
                    />}
                    {!this.props.isLoading && !this.props.error &&
                        <>
                            <div className="card" id="card">
                                <div className="card-body card-body-fill">
                                    <ResponsiveTable>
                                        <table className="table table-report-section table-marketing-list">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th><Translate id="MarketingList.Results.QueryInserted" /></th>
                                                    <th><Translate id="MarketingList.Results.Username" /></th>
                                                    <th><Translate id="MarketingList.Results.Status" /></th>
                                                    {this.isResultsPage() && <th className="ml-count"><Translate id="MarketingList.Results.Count" /></th>}
                                                    {this.isResultsPage() && <th className="ml-count"><Translate id="MarketingList.Results.SubjectsToExport" /></th>}
                                                    <th style={{ textAlign: "right" }} colSpan={2}><Translate id="Common.Action" /></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!isNullOrUndefined(this.props.requests) && this.props.requests.map(
                                                    (r) => {
                                                        return <RequestResultRow key={r.requestId} request={r} />
                                                    }
                                                )
                                                }
                                            </tbody>
                                        </table>
                                    </ResponsiveTable>
                                </div>
                            </div>
                            {this.renderPaging()}
                        </>
                    }
                </div>
                {this.props.overviewState === overviewStates.overview && <div className="content-root" style={{ maxWidth: 'none', backgroundColor: 'transparent', marginBottom: 0, padding: '0' }}>
                    <div className="ml-resizer" style={{ width: '100%', height: '0.25em', cursor: "row-resize", backgroundColor: 'transparent', textAlign: 'center' }} onMouseDown={(e) => this.handleResize(e, 'start')} onDoubleClick={() => this.resetSize()}>
                        <span><SvgBBiconsHandlebar style={{ transform: 'translate(0px, -3px)', width: 50, fill: 'white' }} /></span>
                    </div>
                    <div className={classnames('modal-inner', { 'with-background': localStorage.locales_popup_header_style !== 'filled' })} style={{ height: (this.state.ovHeight || this.height() / 2) + 'px' }}>
                        <ReactResizeDetector handleHeight refreshMode='debounce' refreshRate={500} onResize={() => this.resizeOvContext()} />
                        <div className='popup-filled-header'>
                            <div><Translate id="MarketingList.Results.PreviewOfSubjects" /> <b>{this.props.overviewRequestName ? `${this.props.overviewRequestName} (${this.props.translate("MarketingList.Common.Shortening")}${this.props.overviewRequestId})` : `${this.props.translate("MarketingList.Common.Shortening")}${this.props.overviewRequestId}`}</b></div>
                            <div style={{ display: 'flex' }}>
                                <UnDockIcon className='icon-centered' onClick={() => this.props.toggleMlOverview(overviewStates.window, this.props.overviewRequestId, this.props.overviewExportId, this.props.overviewRequestName)} />
                                <CrossIcon className='icon-centered' onClick={() => this.props.toggleMlOverview(overviewStates.closed, null, null, null)} />
                            </div>
                        </div>
                        <div id="ov-context" className={classnames('modal-inner-content', 'with-background')} style={{ borderBottomLeftRadius: '0px', position: 'relative', height: '80%' }}>
                            <OverviewContent requestId={this.props.overviewRequestId} exportId={this.props.overviewExportId} />
                        </div>
                    </div>
                </div>}
            </div>
        )
    }

    height = () => {
        const ch = getClientWindowHeight();
        const vars = [
            getElementHeight({ className: 'page-nav' }),
            getElementHeight({ className: 'sr-ribbon is-sticky tinted' }),
            getElementHeight({ className: 'tabs tabs-subheader shadowed tinted' }),
            getElementHeight({ className: 'page-footer' })
        ];
        let result = ch - vars.reduce((a, b) => a + b, 0)
        return result;
    }

    ovHeight = () => {
        var h = getElementHeight({ className: 'popup-filled-header' });
        var r = getElementHeight({ className: 'ml-resizer' });
        return (this.state.ovHeight || this.height() / 2) - h - r;
    }

    resizeOvContext = () => {
        document.getElementById('ov-context').style.height = this.ovHeight() + 'px';
    }

    resetSize = () => {
        this.setState({ ovHeight: this.height() / 2 });
    }

    handleResize = (event, type) => {
        if (!this.state.resizing) {
            if (type == 'start') {
                this.setState({
                    resizing: true,
                    initialHeight: this.state.ovHeight || this.height() / 2,
                    startPositionY: event.clientY
                });
            }
        } else {
            if (type == 'move') {
                const finalHeight = this.getNewHeight(event);
                this.setState({ ovHeight: finalHeight });
            } else if (type == 'end') {
                this.setState({ resizing: false });
            }

            event.preventDefault();
            event.stopPropagation();
        }
    }

    getNewHeight = (event) => {
        const height = this.height();
        let expected = this.state.ovHeight || height / 2;
        if (event !== null) {
            expected = this.state.initialHeight - (event.clientY - this.state.startPositionY);
        }
        return Math.max(height * 0.05, Math.min(expected, height * 0.95));
    }

    handleMouseMove = (e) => this.handleResize(e, 'move');
    handleMouseUp = (e) => this.handleResize(e, 'end');
    handleMouseLeave = (e) => this.handleResize(e, 'end');

    onAutoRefresh(value) {
        this.setState({ autoRefresh: value });
        if (value)
            this.setTimer(5000);
    }

    setTimer(ms) {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.loadData, ms);
    }

    loadData = () => {
        this.getRequestsOrTemplates(this.props.page - 1, this.props.pageSize);
    }

    renderPaging = () =>
        (this.props.page && this.props.pageSize && Math.ceil(this.props.totalCount / this.props.pageSize) > 1) ? (
            <div className='paging-wrapper'>
                <Paging selectedPage={this.props.page}
                    totalPages={Math.ceil(this.props.totalCount / this.props.pageSize)}
                    setPage={page => { this.getRequestsOrTemplates(page - 1, this.props.pageSize); this.props.setPage(page) }} />
            </div>
        ) : null;

    isResultsPage = () => this.props.path === `/unicorn/${unicornCountry()}/results` || this.props.path === `/unicorn/${unicornCountry()}/file/:id`;

    getRequestsOrTemplates = (page, pageSize) => {
        // Previous request has not yet finished, try later
        if (this.props.isLoading === true) {
            this.setTimer(1000);
            return;
        }

        this.isResultsPage() ? this.props.getRequests(page, pageSize) : this.props.getTemplates(page, pageSize);
    }
}

export default withLocalize(withRouter(connect(
    state => ({ ...state.marketingList, user: state.userContext }),
    dispatch => bindActionCreators(Object.assign({}, marketingListActions, layoutActions), dispatch)
)(MarketingListResults)));
